export default __webpack_public_path__ + "static/sf-version-20240717-a59f4f11abd022f00d634f92805ac013.png";